import { render } from "./DashProfileShortcuts.vue?vue&type=template&id=5a185b43"
import script from "./DashProfileShortcuts.vue?vue&type=script&lang=js"
export * from "./DashProfileShortcuts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__